import React from 'react';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Card } from 'ui-components/components/card';
import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import styles from './styles.module.less';

type SystemCardProps = {
  isLossPreventionEnabled: boolean;
  onToggle: (enabled: boolean) => void;
};

export const SystemCard = ({ isLossPreventionEnabled, onToggle }: SystemCardProps) => {
  return (
    <Card>
      <FlexRow className={styles.header}>
        <Text textType={TextType.H3} value={messages.title} />
        <CheckboxSlider checkboxId='system-card-toggle' checked={isLossPreventionEnabled} onChange={onToggle} />
      </FlexRow>
      <Text className={styles.description} textType={TextType.Description} value={messages.description} />
      {!isLossPreventionEnabled ? (
        <BannerMessageV2
          className={styles['info-banner']}
          content={<Text textType={TextType.Description} value={messages.warningBannerMessage} />}
          header={<Text textType={TextType.Label} value={messages.warningBannerTitle} />}
          status={BannerStatus.Warning}
        />
      ) : null}
    </Card>
  );
};
